<template>
	<div :class="['container__filtrograficofazendaitem', { selecionado: isChecked }]">
		<p>{{ label }}</p>
		<p>{{ valorFormatado }}</p>
		<span class="container__filtrograficofazendaitem__progress">
			<span
				class="container__filtrograficofazendaitem__progress__value"
				:style="progressValueStyle"
			/>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Cor da barra de progresso
		 */
		color: { type: String, required: true },
		/**
		 * Verifica se o filtro esta selecionado ou nao para ser exibido
		 */
		isChecked: Boolean,
		/**
		 * Label que sera exibido para cada item do filtro
		 */
		label: { type: String, required: true },
		/**
		 * Valor máximo da barra de progresso
		 */
		maxProgressValue: { type: Number, required: true },
		/**
		 * Valor que deve ser exibido para cada item do filtro
		 */
		valor: { type: Number, required: true },
		/**
		 * Qual é a propriedade que está selecionada (Volume Total, Volume Médio ou IMA)
		 */
		propriedadeSelecionada: { type: String, required: true },
	},
	computed: {
		/**
		 * Estilo da barra de progresso
		 */
		progressValueStyle() {
			let backgroundColor = this.isChecked ? this.color : '#d5d5d5'
			let width = `${(100 * this.valor) / this.maxProgressValue}%`
			return { backgroundColor, width }
		},

		/**
		 * Valor formatado com a unidade
		 */
		valorFormatado() {
			const unidades = {
				volumeTotal: '(m³)',
				volumeMedio: '(m³/ha)',
				incrementoMedioAnual: '(m³/ha/ano)',
			}

			return `${this.valor} ${unidades[this.propriedadeSelecionada]}`
		},
	},
}
</script>

<style scoped>
.container__filtrograficofazendaitem {
	width: 100%;
}

.container__filtrograficofazendaitem p {
	margin: 0;
}

.container__filtrograficofazendaitem p:first-child {
	font-weight: 600;
}

.container__filtrograficofazendaitem.selecionado {
	color: rgb(var(--color-primary));
}

.container__filtrograficofazendaitem__progress {
	display: flex;
	width: 100%;
	height: 5px;
	background-color: rgb(var(--color-neutral));
	border-radius: 50px;
	overflow: hidden;
}

.container__filtrograficofazendaitem__progress__value {
	transition: all 0.2s linear;
}
</style>
